//import * as firebase from "firebase";
//import "firebase/firestore";
//import usersData from "../data/usersData";

import firebase from "firebase/app";
import "firebase/database";
import "firebase/functions";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  //storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const database = firebase.firestore();
const functions = firebase.functions();
const auth = firebase.auth();

export { firebase, auth, functions, database as default };
